export default "__VITE_ASSET__Dt1q$WJx__"